/**
 * withOrders
 * HOC for wrapping the provided component with OrdersProvider
 */

import React from 'react'

import OrdersProvider from './orders-provider'

export default function withOrders (WrappedComponent) {
  return function OrdersProviderHOC(props) {
    return (
      <OrdersProvider>
        <WrappedComponent {...props} />
      </OrdersProvider>
    )
  }
}
